<template>
  <div>


    <div class="d-flex flex-column" style="flex: 1 1 100%">
      <div class="d-flex align-center justify-space-around" style="" v-for="(item, index) in audienceItem" :key="index">
        <v-text-field :label="$t('mainStore.aboutStore.ageGroup.initialAge')" style="flex: 0 0 20%" v-model="item.primaryAge" type="number"
          :min="minFirst(item.primaryAge, index)" :max="99" step="1" :rules="[
            fieldRules.ageMin(item.primaryAge, minFirst(item.primaryAge, index)),
            fieldRules.ageMax(item.primaryAge, 99),
          ]" />
        <span class="mx-4">{{ $t('mainStore.aboutStore.ageGroup.upTo') }}</span>
        <v-text-field :label="$t('mainStore.aboutStore.ageGroup.finalAge')" class="mr-4" style="flex: 0 0 20%" :min="min(item.primaryAge)" max="99" step="1"
          v-model="item.secondAge" :rules="[
            fieldRules.ageMin(item.secondAge, min(item.primaryAge)),
            fieldRules.ageMax(item.secondAge, 99),
            fieldRules.ageCompare(item.secondAge, item.primaryAge),
          
          ]" type="number" />
        <v-text-field style="flex: 0 0 30%" min="0" step="1" max="100" class="ml-6 mr-4" :rules="[
          fieldRules.percentMin(item.percenteField, 0),
          fieldRules.percentMax(item.percenteField, 100),
          fieldRules.percentCompare(total),
        
        ]" type="number" v-model="item.percenteField" suffix="%"></v-text-field>
        <v-btn icon @click="removeAudienceField" color="red" class="ml-4 ">
          <v-icon>mdi-trash-can-outline</v-icon>
        </v-btn>

      </div>
    </div>
    <div class="d-flex justify-end">
      <v-btn icon @click="addAudienceItem" color="green" large>
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-btn>
    </div>
    <!-- <v-icon :disabled="disabledCheck" @click="save" class="ml-4 green--text"
      >mdi-check-circle-outline</v-icon
    > -->

  </div>

</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AudienceFieldVue",

  data() {
    return {
      disabledCheck: true,
      fieldRules: {
        percentMin(value, min) {
          return (value || "") >= min || `Valor da porcentagem mínima ${min}`;
        },
        percentMax(value, max) {
          return (value || "") <= max || `Valor da porcentagem máxima ${max} `;
        },
        ageMin(value, min) {
          return (value || "") >= min || `Edad mínima ${min}`;
        },
        ageMax(value, max) {
          return (value || "") <= max || `Edad máxima ${max} `;
        },
        ageCompare(value, compare) {
          return value == compare ? 'O range de idade não pode ser igual' : true
        },
        percentCompare(value) {
          return value != 100 ? 'La suma de los porcentajes de los grupos debe completar 100% al final' : true
        },
      },

      audienceItem: [
        { primaryAge: null, secondAge: null, percenteField: null },
      ],
      item: {
        primaryAge: null,
        secondAge: null,
        percenteField: null,
      },
    };
  },
  props: {
    groups: Array
  },
  watch: {
    audienceItem: {
      deep: true,
      handler() {
        this.save()
      }
    },
    'selectedStore': {
            deep: true,
            haldler(){
              this.audienceItem = this.groups
            }
        },
  },
  mounted(){
    this.audienceItem = this.groups
  },


    computed: {
        ...mapState("groupStores", [
            "selectedStore",
        ]),
        
    total() {
      let sum = 0
      const result = this.audienceItem.reduce((total, current) => total + (isNaN(parseFloat(current.percenteField)) ? 0 : (parseFloat(current.percenteField))), sum)
      return result
    },

  },

  methods: {
    minFirst(value, index) {
      if (index == 0) {
        return 0
      }
      else {
        return parseFloat(this.audienceItem[index - 1].secondAge) + 1
      }
    },
    min(value) {
      return parseFloat(value) + 1
    },
    save() {
      this.$emit('update-store', this.audienceItem)
    },

    addAudienceItem() {
      let objItem = {
        primaryAge: null,
        secondAge: null,
        percenteField: null,
      };
      this.audienceItem.push(objItem);
      this.disabledCheck = false
    },
    removeAudienceField() {
      let objItem = {
        primaryAge: null,
        secondAge: null,
        percenteField: null,
      };
      this.audienceItem.pop(objItem);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
